import { Reservations } from '../api';
import { from, of, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import corporateAccountStore, { CorporateAccountStore } from './corporate-account.store';

export class CorporateAccountService {
  constructor(
    private readonly corporateAccountApi: Reservations.CorporateAccountApi,
    private readonly store: CorporateAccountStore
  ) {}

  getMyAccounts() {
    from(this.corporateAccountApi.corporateaccountMyAccountsGet())
      .pipe(
        map(data => data.data),
        catchError(error => (error?.response?.status === 404 ? of([]) : throwError(error))),
        finalize(() => this.store.setLoading(false))
      )
      .subscribe(data => {
        this.store.set(data);
        this.store.update({ loaded: true });
      });
  }
}
export const corporateAccountService = new CorporateAccountService(
  new Reservations.CorporateAccountApi(),
  corporateAccountStore
);
